import RegistrationBanner from "@/components/home/RegistrationBanner";
import MembershipCategories from "@/components/home/MembershipCategories";
import FederationIntro from "@/components/home/FederationIntro";
import WhyJoin from "@/components/home/WhyJoin";
import UpcomingChampionships from "@/components/home/UpcomingChampionships";
import Announcements from "@/components/home/Announcements";
import InitiativesGrid from "@/components/home/InitiativesGrid";
import Reveal from "@/components/Reveal";

export default function Home() {
  return (
    <div data-testid="home-page">
      <RegistrationBanner />
      <Reveal delay={60}><MembershipCategories /></Reveal>
      <Reveal delay={80}><FederationIntro /></Reveal>
      <Reveal delay={60}><UpcomingChampionships /></Reveal>
      <Reveal delay={80}><WhyJoin /></Reveal>
      <Reveal delay={60}><Announcements /></Reveal>
      <Reveal delay={80}><InitiativesGrid /></Reveal>
    </div>
  );
}
